<template>
        
    <div class="card">
        <div class="card-body">

            <h4 
                class="card-title"
                :class="($i18n.locale == 'ar') ? 'hacen_algeria font-size-15' : ''">
                {{ $t('app.choose_contracttypes') }}
            </h4>
            <div class="col-md-12 text-center" style="padding:0">
                <span 
                    v-if="contractTypeLoading"
                    class="spinner-grow spinner-grow-sm mr-1" 
                    role="status" 
                    aria-hidden="true">
                </span>
                <select 
                    v-if="!contractTypeLoading"
                    id="transactionType"
                    class="form-control" 
                    :class="($i18n.locale == 'ar') ? 'hacen_algeria font-size-15' : ''"
                    v-model="row.contract_type_id"
                    v-on:change="onInputChange">
                    <option 
                        v-for="(row, idx) in contractTypes" 
                        :key="idx"
                        :value="row.id">
                        {{ ($i18n.locale == 'ar') ? row.ar.title : row.en.title }}
                    </option>
                </select>
            </div>
        </div>
    </div>
        
</template>

<script>
import iziToast from 'izitoast';

export default {
    namme: 'CardContractType',
    props: [
        'contract_type_id'
    ],
    data(){
        return {
            auth: {
                access_token: ''
            },
            row: {
                contract_type_id: this.$props.contract_type_id
            },
            contractTypes: [],
            contractTypeLoading: true,
        }
    },
    mounted() {},
    created() {
        if(localStorage.getItem('access_token')) {
            this.auth.access_token = localStorage.getItem('access_token');
        }

        this.fetchData();
    },
    methods: {
        onInputChange(){
            const data = {
                contract_type_id: this.row.contract_type_id
            }
            this.$emit('contractTypeChange', data);
        },

        fetchData() {
            this.contractTypeLoading = true;
            this.axios.defaults.headers.common = {
                'X-Requested-With': 'XMLHttpRequest', // security to prevent CSRF attacks
                'Authorization': `Bearer ` + this.auth.access_token,
            };
            const options = {
                url: window.baseURL+'/contracttypes',
                method: 'GET',
                data: {},
                params: {
                    status: 'active',
                    paginate: 1000
                }
            }
            this.axios(options)
            .then(res => {
                this.contractTypeLoading = false;
                this.contractTypes = res.data.data.rows;
            })
            .catch(err => {
                this.contractTypeLoading = false;
                iziToast.warning({
                    icon: 'bx bx-angry',
                    title: '',
                    message: (err.response) ? err.response.data.message : ''+err
                });
            })
        },
    }
}
</script>
